/* eslint-disable */
import React from 'react'
import { useTranslation } from 'react-i18next';

// MUI
import LaunchIcon from '@mui/icons-material/Launch';
import { PhotoCamera } from '@mui/icons-material';

// Types
import { TCustomGFIActionProps } from '@/@types/views/map'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

const ShowPhotodocButtonListItem = (props: TCustomGFIActionProps) => {

    const { t } = useTranslation();

    const { featureData, layerIndex = 0, type } = props;

    const handleShowPhotodoc = () => {
        const properties = featureData.features[layerIndex].properties;
        const id = type === 'grobno_mjesto' ? properties.id : properties.objekt_id;

        const basePath = type === 'grobno_mjesto' ? 'groblja' : 'ena';

        if (id) {
            const url = `${location.origin}/${basePath}/photodoc/?rec_id=${id.toString()}`;
            window.open(url, '_blank');
        }
    };

    return (
        <MenuItem onClick={handleShowPhotodoc}>
        <ListItemIcon>
            <PhotoCamera color="primary"/>
        </ListItemIcon>
        <ListItemText>{t('buttons.show_photos')}</ListItemText>
        <LaunchIcon sx={{ ml: 1 }} color="disabled" fontSize="small" />
        </MenuItem>
    )
}

export default ShowPhotodocButtonListItem